module.exports = __webpack_public_path__ + "img/logo_footer.2f46883b.png";